// List all packaging options, and specify which textures cause them to become active

export type PackagingOption = {
  name: string;
  value: string;
  textures: string[];
};

export const packagingOptions: PackagingOption[] = [
  {
    name: 'topics:packaging:options:pumpDispenser',
    value: 'pump-dispenser',
    textures: ['fluid', 'serum', 'gel', 'lotion', 'cream', 'liquid', 'other'],
  },
  {
    name: 'topics:packaging:options:sprayDispenser',
    value: 'spray-dispenser',
    textures: ['fluid', 'serum', 'gel', 'lotion', 'liquid', 'other'],
  },
  {
    name: 'topics:packaging:options:jar',
    value: 'jar',
    textures: [
      'fluid',
      'serum',
      'gel',
      'lotion',
      'cream',
      'solid',
      'foam',
      'liquid',
      'other',
      'notApplicable',
    ],
  },
  {
    name: 'topics:packaging:options:tube',
    value: 'tube',
    textures: [
      'fluid',
      'serum',
      'gel',
      'lotion',
      'cream',
      'foam',
      'liquid',
      'other',
      'notApplicable',
    ],
  },
  {
    name: 'topics:packaging:options:aerosol',
    value: 'aerosol',
    textures: ['spray', 'aerosol', 'other', 'notApplicable'],
  },
  {
    name: 'topics:packaging:options:sachet',
    value: 'sachet',
    textures: [
      'serum',
      'gel',
      'lotion',
      'cream',
      'powder',
      'liquid',
      'other',
      'notApplicable',
    ],
  },
  {
    name: 'topics:packaging:options:bagInCan',
    value: 'bag-in-can',
    textures: ['spray', 'aerosol', 'other', 'notApplicable'],
  },
  {
    name: 'topics:packaging:options:airPump',
    value: 'air-pump',
    textures: ['spray', 'other', 'notApplicable'],
  },
  {
    name: 'topics:packaging:options:bag',
    value: 'bag',
    textures: ['solid', 'other', 'notApplicable'],
  },
  {
    name: 'topics:packaging:options:carton',
    value: 'carton',
    textures: ['solid', 'other', 'notApplicable'],
  },
  {
    name: 'topics:packaging:options:bottle',
    value: 'bottle',
    textures: ['foam', 'liquid', 'fluid', 'other', 'notApplicable'],
  },
  {
    name: 'topics:packaging:options:compact',
    value: 'compact',
    textures: ['powder', 'other', 'notApplicable'],
  },
  {
    name: 'topics:packaging:options:jarBottle',
    value: 'jar-bottle',
    textures: ['powder', 'other', 'notApplicable'],
  },
  {
    name: 'topics:packaging:options:other',
    value: 'other',
    textures: [
      'fluid',
      'serum',
      'gel',
      'lotion',
      'cream',
      'foam',
      'other',
      'powder',
      'solid',
      'spray',
      'aerosol',
      'liquid',
      'notApplicable',
    ],
  },
];
